import { createXRStore } from '@react-three/xr'

// Real WebXR only — no IWER emulator. Runs against the headset's native navigator.xr.
const baseAssetPath =
  typeof location !== 'undefined'
    ? new URL(`${import.meta.env.BASE_URL}webxr-profiles/`, location.origin).href
    : undefined

export const xrStore = createXRStore({
  // @react-three/xr defaults controller/hand profiles to a jsdelivr CDN, which fails on the
  // offline headset and kills all controller input (no gamepad → no buttons). Serve the
  // vendored layout JSON same-origin instead (see scripts/copy-xr-profiles.mjs).
  baseAssetPath,
  // Passthrough shows the real controllers/hands; skip the virtual glb models (also CDN-hosted).
  controller: { model: false },
  hand: { model: false },
  frameRate: 'high',
  foveation: 1,
  handTracking: true,
  // plane/mesh detection drive RealWorldColliders (virtual models collide with the real table /
  // floor / walls). Both map to optionalFeatures, so a runtime without them just yields no
  // planes/meshes rather than failing session init.
  planeDetection: true,
  meshDetection: true,
  // Other deferred Meta features — not used yet. Requesting them (even as optionalFeatures) has
  // made the Quest runtime reject session init; re-enable each when actually implemented.
  hitTest: false,
  anchors: false,
  depthSensing: false,
  layers: false,
  domOverlay: false,
  // We drive session entry explicitly (lobby button + in-XR switch). The library's proactive
  // navigator.xr.offerSession() re-fires on every session end and collides with the still-pending
  // initial offer → "OfferSession called more than once" when switching MR↔VR. Not needed here.
  offerSession: false,
  emulate: false,
})
